<div style="margin-right:0.5em;">
  @for (allowedAction of AllowedActions; track allowedAction) {
    <button class="button" style="margin-left:5px;" [ngStyle]="{'background-color' : '#' + allowedAction.BackgroundColor, 'color': '#' + allowedAction.ForegroundColor }" (click)="performAction(allowedAction)"><i [ngClass]="'fa fa-' + allowedAction.IconName" style="margin-right:5px"></i><span>{{allowedAction.Name}}</span></button>
  }
</div>